/* =========================================================================
   Bloomi theme — global.js
   Minimal progressive enhancement: mobile menu toggle + AJAX add-to-cart.
   Everything degrades gracefully without JS.
   ========================================================================= */
(function () {
  'use strict';

  /* ----- Mobile menu toggle ----- */
  function initMobileMenu() {
    var burger = document.querySelector('[data-burger]');
    var panel = document.querySelector('[data-mobile-nav]');
    if (!burger || !panel) return;

    burger.addEventListener('click', function () {
      var open = panel.getAttribute('data-open') === 'true';
      panel.setAttribute('data-open', String(!open));
      burger.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ----- Update the cart bubble count ----- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  /* ----- AJAX add-to-cart (falls back to normal form POST without JS) ----- */
  function initAddToCart() {
    document.querySelectorAll('form[data-add-to-cart]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        // Only intercept when fetch is available.
        if (!window.fetch) return;
        event.preventDefault();

        var button = form.querySelector('[type="submit"]');
        var original = button ? button.textContent : '';
        if (button) { button.disabled = true; button.textContent = 'Ajouté ✓'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
          body: new URLSearchParams(new FormData(form)).toString()
        })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) { setCartCount(cart.item_count); })
          .catch(function () { /* silent — cart page still works */ })
          .finally(function () {
            if (button) {
              window.setTimeout(function () {
                button.disabled = false;
                button.textContent = original;
              }, 1400);
            }
          });
      });
    });
  }

  /* ----- Product gallery: thumbnail swap + fullscreen lightbox ----- */
  function initProductGallery() {
    var main = document.getElementById('GalleryMain');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
    var current = 0; // index of the image currently shown in the main slot

    // Warm the cache so secondary images appear instantly (main swap + lightbox
    // share the same 1200px URL, so each downloads only once).
    function warm(url) { if (url) { var im = new Image(); im.src = url; } }

    // Thumbnail → swap main image (+ prefetch on hover/focus)
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) { main.src = full; main.srcset = ''; }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        current = i;
      });
      thumb.addEventListener('mouseenter', function () { warm(thumb.getAttribute('data-full')); });
      thumb.addEventListener('focus', function () { warm(thumb.getAttribute('data-full')); });
    });

    // Prefetch all full-size images once the browser is idle after load.
    var idle = window.requestIdleCallback || function (cb) { return window.setTimeout(cb, 1200); };
    idle(function () {
      thumbs.forEach(function (t) { warm(t.getAttribute('data-full')); });
    });

    // Lightbox
    var lb = document.querySelector('[data-lightbox]');
    if (!lb) return;
    var slides = Array.prototype.slice.call(lb.querySelectorAll('.lightbox__slide'));
    var track = lb.querySelector('[data-lb-track]');
    var counter = lb.querySelector('[data-lb-current]');
    var opener = document.querySelector('[data-gallery-open]');
    var lbIndex = 0;

    function show(i) {
      lbIndex = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-lbIndex * 100) + '%)';
      if (counter) counter.textContent = String(lbIndex + 1);
    }
    function open(i) {
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      show(i || 0);
    }
    function close() {
      lb.hidden = true;
      document.body.style.overflow = '';
    }

    if (opener) {
      opener.addEventListener('click', function () { open(current); });
      opener.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(current); }
      });
    }

    var next = lb.querySelector('[data-lb-next]');
    var prev = lb.querySelector('[data-lb-prev]');
    var closeBtn = lb.querySelector('[data-lb-close]');
    if (next) next.addEventListener('click', function () { show(lbIndex + 1); });
    if (prev) prev.addEventListener('click', function () { show(lbIndex - 1); });
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Click the dark backdrop to close
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(lbIndex + 1);
      if (e.key === 'ArrowLeft') show(lbIndex - 1);
    });

    // Touch swipe
    var startX = null;
    lb.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { show(dx < 0 ? lbIndex + 1 : lbIndex - 1); }
      startX = null;
    });
  }

  /* ----- Flipbook: "Feuilleter le livre" (scroll carousel, 2-up / 1-up) ----- */
  function initFlipbook() {
    document.querySelectorAll('[data-flipbook]').forEach(function (root) {
      var viewport = root.querySelector('[data-flip-viewport]');
      var pages = Array.prototype.slice.call(root.querySelectorAll('.flipbook__page'));
      if (!viewport || !pages.length) return;

      var prev = root.querySelector('[data-flip-prev]');
      var next = root.querySelector('[data-flip-next]');
      var track = root.querySelector('.flipbook__track');
      var counter = root.parentNode.querySelector('[data-flip-current]');

      function step() {
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap) || 0;
        return pages[0].getBoundingClientRect().width + gap;
      }
      function update() {
        if (!counter) return;
        var idx = Math.round(viewport.scrollLeft / step());
        counter.textContent = String(Math.min(pages.length, idx + 1));
      }

      if (next) next.addEventListener('click', function () { viewport.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { viewport.scrollBy({ left: -step(), behavior: 'smooth' }); });

      var ticking = false;
      viewport.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { update(); ticking = false; });
      });
      update();
    });
  }

  /* ----- Sticky order bar: appears when the form leaves the viewport ----- */
  function initBuyBar() {
    var bar = document.querySelector('[data-buybar]');
    var form = document.getElementById('OrderForm');
    var cta = document.querySelector('[data-buybar-cta]');
    var firstInput = document.getElementById('OrderName');
    if (!bar || !form) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        // Hide the bar while the form is on screen, show it otherwise.
        bar.hidden = entries[0].isIntersecting;
      }, { rootMargin: '0px 0px -25% 0px' });
      io.observe(form);
    } else {
      bar.hidden = false;
    }

    if (cta) {
      cta.addEventListener('click', function () {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        form.classList.add('order-card--flash');
        window.setTimeout(function () { form.classList.remove('order-card--flash'); }, 1000);
        if (firstInput) {
          window.setTimeout(function () { firstInput.focus({ preventScroll: true }); }, 480);
        }
      });
    }
  }

  /* ----- Order form validation (name, Moroccan phone, city, address) ----- */
  function initOrderForm() {
    var form = document.getElementById('OrderForm');
    if (!form) return;

    var name = form.querySelector('#OrderName');
    var phone = form.querySelector('#OrderPhone');
    var city = form.querySelector('#OrderCity');
    var address = form.querySelector('#OrderAddress');

    function clearError(input) {
      if (!input) return;
      input.removeAttribute('aria-invalid');
      var e = input.parentNode.querySelector('.field-error');
      if (e) e.parentNode.removeChild(e);
    }
    function setError(input, msg) {
      if (!input) return;
      clearError(input);
      input.setAttribute('aria-invalid', 'true');
      var e = document.createElement('p');
      e.className = 'field-error';
      e.textContent = msg;
      input.parentNode.appendChild(e);
    }
    function validPhone(v) {
      var d = v.replace(/[\s\-().]/g, '');
      // Moroccan: 05/06/07 + 8 digits (10 total), or +212 / 00212 prefix.
      return /^0[5-7]\d{8}$/.test(d) || /^\+212[5-7]\d{8}$/.test(d) || /^00212[5-7]\d{8}$/.test(d);
    }

    [name, phone, city, address].forEach(function (input) {
      if (input) input.addEventListener('input', function () { clearError(input); });
    });

    form.addEventListener('submit', function (e) {
      var firstInvalid = null;
      function check(cond, input, msg) {
        if (cond) { clearError(input); }
        else { setError(input, msg); if (!firstInvalid) firstInvalid = input; }
      }

      check(name && name.value.trim().length >= 3, name, 'Veuillez saisir votre nom complet.');
      check(phone && validPhone(phone.value), phone, 'Numéro invalide. Exemple : 06 12 34 56 78');
      check(city && city.value.trim().length >= 2, city, 'Veuillez indiquer votre ville.');
      check(address && address.value.trim().length >= 5, address, 'Veuillez saisir une adresse complète.');

      // Always handle submission ourselves — never go to Shopify checkout.
      e.preventDefault();

      if (firstInvalid) {
        firstInvalid.focus();
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var thankyou = form.getAttribute('data-thankyou');
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Envoi en cours...'; }

      function get(sel) { var el = form.querySelector(sel); return el ? el.value : ''; }
      var variant = '';
      var vs = form.querySelector('#VariantSelect');
      if (vs) variant = vs.options[vs.selectedIndex].text;

      var order = {
        reference: 'BL-' + String(Date.now()).slice(-6),
        nom: name.value.trim(),
        telephone: phone.value.trim(),
        ville: city.value.trim(),
        adresse: address.value.trim(),
        quantite: get('[name="quantity"]') || '1',
        produit: get('[name="product"]'),
        variante: variant,
        prix: get('[name="prix"]'),
        url_produit: get('[name="url_produit"]')
      };
      try { sessionStorage.setItem('bloomi_order', JSON.stringify(order)); } catch (err) {}

      function done() {
        // If a thank-you page URL is configured, redirect there.
        if (thankyou) { window.location.href = thankyou; return; }
        // Otherwise show the in-page confirmation overlay.
        var overlay = document.querySelector('[data-order-success]');
        if (overlay) {
          overlay.querySelectorAll('[data-s]').forEach(function (el) {
            var k = el.getAttribute('data-s');
            if (order[k]) el.textContent = order[k];
          });
          overlay.hidden = false;
          document.body.style.overflow = 'hidden';
        } else if (btn) {
          btn.disabled = false;
          btn.textContent = 'Commande envoyée ✓';
        }
      }

      // Save to the Google Sheet (if configured), then confirm.
      var sheet = form.getAttribute('data-sheet');
      if (sheet && window.fetch) {
        var payload = new URLSearchParams();
        Object.keys(order).forEach(function (k) { payload.set(k, order[k]); });
        fetch(sheet, { method: 'POST', mode: 'no-cors', body: payload })
          .then(done)
          .catch(done);
      } else {
        done();
      }
    });

    // Close the confirmation overlay
    var successClose = document.querySelector('[data-success-close]');
    var overlayEl = document.querySelector('[data-order-success]');
    if (successClose && overlayEl) {
      successClose.addEventListener('click', function () {
        overlayEl.hidden = true;
        document.body.style.overflow = '';
      });
      overlayEl.addEventListener('click', function (e) {
        if (e.target === overlayEl) { overlayEl.hidden = true; document.body.style.overflow = ''; }
      });
    }
  }

  /* ----- Thank-you page: fill the order recap from the saved order ----- */
  function initThankYou() {
    var recap = document.querySelector('[data-order-recap]');
    if (!recap) return;
    var data;
    try { data = JSON.parse(sessionStorage.getItem('bloomi_order') || 'null'); } catch (e) { data = null; }
    if (!data) return;

    recap.querySelectorAll('[data-recap]').forEach(function (el) {
      var key = el.getAttribute('data-recap');
      if (data[key]) el.textContent = data[key];
    });
    var ref = recap.querySelector('[data-order-ref]');
    if (ref && data.reference) ref.textContent = 'N° ' + data.reference;
    recap.hidden = false;
    // Show it only once.
    try { sessionStorage.removeItem('bloomi_order'); } catch (e) {}
  }

  /* ----- Free download: shared email popup → capture → reveal download ----- */
  function initFreeDownload() {
    var modal = document.querySelector('[data-download-modal]');
    var form = modal && modal.querySelector('[data-download-form]');
    if (!modal || !form) return;

    var closeBtn = modal.querySelector('[data-download-close]');
    var done = modal.querySelector('[data-download-done]');
    var link = modal.querySelector('[data-download-link]');
    var emailNote = modal.querySelector('[data-download-email-note]');
    var submitBtn = form.querySelector('[type="submit"]');
    var submitLabel = submitBtn ? submitBtn.textContent : '';
    var currentUrl = '';
    var currentProduct = '';

    function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }
    function reset() {
      form.hidden = false;
      if (done) done.hidden = true;
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitLabel; }
      var email = form.querySelector('input[type="email"]');
      if (email) email.value = '';
    }

    // Any download button on the page (cards + product page)
    document.querySelectorAll('[data-download-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentUrl = btn.getAttribute('data-dl-url') || '';
        currentProduct = btn.getAttribute('data-dl-product') || '';
        reset();
        open();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (!modal.hidden && e.key === 'Escape') close(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]');
      if (!email || !email.value) return;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Envoi...'; }
      var sheet = form.getAttribute('data-sheet');

      function finish() {
        form.hidden = true;
        if (done) done.hidden = false;
        if (currentUrl) {
          if (link) { link.href = currentUrl; link.hidden = false; }
          if (emailNote) emailNote.hidden = true;
          window.setTimeout(function () { window.open(currentUrl, '_blank'); }, 400);
        } else {
          if (link) link.hidden = true;
          if (emailNote) emailNote.hidden = false;
        }
      }

      if (sheet && window.fetch) {
        var payload = new URLSearchParams();
        payload.set('email', email.value.trim());
        payload.set('produit', currentProduct);
        payload.set('type', 'telechargement gratuit');
        payload.set('page', window.location.href);
        fetch(sheet, { method: 'POST', mode: 'no-cors', body: payload }).then(finish).catch(finish);
      } else {
        finish();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initAddToCart();
    initProductGallery();
    initFlipbook();
    initBuyBar();
    initOrderForm();
    initThankYou();
    initFreeDownload();
  });
})();
